
ADILF.define('adilf/apps/wall/app',['require','exports','module','streamhub-sdk/jquery','adilf/handler','adilf/util/config-validator','streamhub-sdk/collection','css!streamhub-sdk/css/style'],function (require, exports, module) {/* Application: Livefyre Wall (Gallery) */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Handler = require('adilf/handler');
var ConfigValidator = require('adilf/util/config-validator');
var Collection = require('streamhub-sdk/collection');
require('css!streamhub-sdk/css/style');

var Wall = function(conf) {
    var self = this;
    conf = conf || {};
    self.conf = conf;
    self.instance = undefined;

    if(!ConfigValidator.call(self, {
        app: "Wall",
        defaultEl: "lf-wall",
        required: ['networkId', 'articleId']
    })) return;

    Handler.apps[self.conf.name] = self;
    if(self.conf.autoStart) self.init();
};

Wall.prototype.init = function() {
    var self = this;
    window.Livefyre.require(['streamhub-wall#3.5'], function(WallView) {
        self.instance = new WallView({
            el: self.conf.el
        });
        self.collection = new Collection({
            network: self.conf.networkId,
            siteId: self.conf.siteId,
            articleId: self.conf.articleId
        });
        self.collection.pipe(self.instance);
        self.debug.print("Initialized");
    });
};

module.exports = Wall;
});
